import moment from 'moment';
import BirchlandMarket from '@/components/customercenter-ui/svgs/birchlandMarketLogo';
import DiscoverIcon from '@/components/customercenter-ui/svgs/discover';
import FifthAndGlamCredit from '@/components/customercenter-ui/svgs/fifthAndGlamCredit';
import FBLogo from '@/components/customercenter-ui/svgs/figisGalleryLogoFB';
import FGLogo from '@/components/customercenter-ui/svgs/figisGiftsLogoFG';
import KJordan from '@/components/customercenter-ui/svgs/kJordanlogo';
import MasonCredit from '@/components/customercenter-ui/svgs/masonCredit';
import MasonEasyPay from '@/components/customercenter-ui/svgs/masonEasyPay';
import MasterCardIcon from '@/components/customercenter-ui/svgs/masterCard';
import StoneBerryCredit from '@/components/customercenter-ui/svgs/stoneBerry';
import VisaIcon from '@/components/customercenter-ui/svgs/visaIcon';
import AmericanExpressIcon from '@/customercenter-ui/icons/americanExpress';
import { MONTH_YEAR_FORMAT } from '../../../../../constants/constant';
import { CARD_NAMES, PAYLOAD_QUERY } from '../../customer-detail/constants';
import { Payment, ShippingAndBillingDetailsType } from '../types';

export const getCardIcon = (creditCardType: string) => {
  switch (creditCardType?.toLowerCase()) {
    case CARD_NAMES.VISA:
      return <VisaIcon className="h-12 w-12" />;
    case CARD_NAMES.MASTERCARD:
      return <MasterCardIcon className="h-12 w-12" />;
    case CARD_NAMES.DISCOVER:
      return <DiscoverIcon className="h-12 w-12" />;
    case CARD_NAMES.AMERICAN_EXPRESS:
      return <AmericanExpressIcon className="h-12 w-12" />;
    default:
      return null;
  }
};

export const getCurrentDivisionPaymentSvg = (divisionCode: string) => {
  switch (divisionCode) {
    case 'ZB':
      return <StoneBerryCredit />;
    case 'ZY':
      return <MasonCredit />;
    case 'ZD':
      return <MasonEasyPay />;
    case 'ZC':
      return <FifthAndGlamCredit />;
    case 'ZA':
      return <KJordan />;
    case 'ZF':
      return <BirchlandMarket />;
    case 'FB':
      return <FBLogo />;
    case 'FG':
      return <FGLogo />;
    default:
      return <></>;
  }
};

export const getPaymentMethodSvgs = (
  paymentMethod: string,
  Payments: Payment[],
  Texts: { [Texts: string]: string },
  billingDetails: ShippingAndBillingDetailsType,
  params: any,
  batchId?: string,
) => {
  switch (paymentMethod) {
    case 'CreditCard':
      return (
        <section className="mb-8 flex flex-col gap-2">
          <li className="flex items-center">
            <p className="w-1/3">{Texts.paymentMethod}:</p>
            <p className="gbomit w-2/3">{getCardIcon(Payments?.[0]?.PaymentDetail?.cardIssuerName)}</p>
          </li>
          <li className="flex items-center">
            <p className="w-1/3">{Texts.cardNumber}:</p>
            <p className="gbmask w-2/3">
              {Texts.cardFormat}
              {Payments?.[0]?.PaymentDetail?.lastDigitsOfPan}
            </p>
          </li>
          <li className="flex items-center">
            <p className="w-1/3">{Texts.expDate}:</p>
            <p className="gbmask w-2/3">
              {moment(Payments?.[0]?.PaymentDetail?.expirationDate, 'MMYY').format(MONTH_YEAR_FORMAT)}
            </p>
          </li>
        </section>
      );
    case 'MasonCredit':
    case 'FigisCredit':
      return (
        <section className="flex flex-col">
          <li className="mb-8 flex items-center">
            <p className="w-1/3">{Texts.paymentMethod}:</p>
            <p className="gbomit w-2/3">
              {getCurrentDivisionPaymentSvg(params?.get(PAYLOAD_QUERY.DIVISION_CODE) ?? '')}
            </p>
          </li>
          <li className="mb-8 flex">
            <p className="w-1/3">{Texts.accountNumber}</p>
            <p className="gbmask w-2/3">{billingDetails?.orderInfo?.omsCustomerId}</p>
          </li>
        </section>
      );
    case 'Check':
      return (
        <section className="mb-8 flex flex-col gap-2">
          <li className="flex items-center">
            <p className="w-1/3">{Texts.paymentMethod}:</p>
            <p className="w-2/3">
              {Payments?.[0]?.PaymentInfo?.paymentType ?? Payments?.[0]?.PaymentInfo?.termsDescription}
            </p>
          </li>
          <li className="flex items-center">
            <p className="w-1/3">{Texts.batchNumber}:</p>
            <p className="gbmask w-2/3">{Payments?.[0]?.PaymentDetail?.checkNumber}</p>
          </li>
          <li className="flex items-center">
            <p className="w-1/3">{Texts.batch}:</p>
            <p className="gbmask w-2/3">{batchId}</p>
          </li>
        </section>
      );
    case 'Cash':
      return (
        <section className="mb-8 flex flex-col gap-2">
          <li className="flex items-center">
            <p className="w-1/3">{Texts.paymentMethod}:</p>
            <p className="w-2/3">
              {Payments?.[0]?.PaymentInfo?.paymentType ?? Payments?.[0]?.PaymentInfo?.termsDescription}
            </p>
          </li>
          <li className="flex items-center">
            <p className="w-1/3">{Texts.batch}:</p>
            <p className="gbmask w-2/3">{Payments?.[0]?.PaymentDetail?.batchId ?? batchId}</p>
          </li>
        </section>
      );
    default:
      return (
        <section className="mb-8 flex flex-col gap-2">
          <li className="flex items-center">
            <p className="w-1/3">{Texts.paymentMethod}:</p>
            <p className="w-2/3">
              {Payments?.[0]?.PaymentInfo?.paymentType ?? Payments?.[0]?.PaymentInfo?.termsDescription}
            </p>
          </li>
        </section>
      );
  }
};
